import type { CSSObject } from '@emotion/react'

import type { ResolvedTheme } from './themes'

export const textStyle = (
  metrics: ResolvedTheme['typography']['app']['body']
): CSSObject => ({
  fontSize: `${metrics.fontSize}px`,
  lineHeight:
    metrics.lineHeight === 'auto' ? 'normal' : `${metrics.lineHeight}px`,
  letterSpacing: `${metrics.letterSpacing}px`,
})
